<template>
  <div class="component-details">
    <NavBar></NavBar>
    <main
      property="mainContentOfPage"
      class="container"
      typeof="WebPageElement"
    >
      <Breadcrumb></Breadcrumb>
      <section class="custom-section">
        <div class="columns">
          <div
            class="column is-two-thirds-desktop is-half-tablet is-full-mobile"
          >
            <h1 class="title is-2" v-if="$i18n.locale == 'en'">
              {{ widget.name }}
            </h1>
            <h1 class="title is-2" v-if="$i18n.locale == 'fr'">
              {{ widget.nameFr }}
            </h1>
          </div>
        </div>
        <div class="columns">
          <div
            class="column is-two-thirds-desktop is-half-tablet is-full-mobile"
          >
            <div class="large-text" v-if="$i18n.locale == 'en'">
              {{ widget.description }}
            </div>
            <div class="large-text" v-if="$i18n.locale == 'fr'">
              {{ widget.descriptionFr }}
            </div>
            <br />
            <p class="large-text">
              {{ $t("widget_details.additional_description") }}
            </p>
            <!-- widget example starts here -->
            <div ref="example" class="example-image">
              <WidgetExample :widget="widget"></WidgetExample>
            </div>
            <!--  
            <div v-if="widget.id == '5'">
              <div
                class="is-size-5 mt-5"
                v-if="$i18n.locale == 'en'"
                v-html="widget.tool_option"
              >
              </div>
              <div
                class="is-size-5 mt-5"
                v-if="$i18n.locale == 'fr'"
                v-html="widget.tool_optionFr"
              >
              </div>
            </div> 
            -->
          </div>

          <!-- site navigation box starts here -->
          <div
            class="column is-one-third-desktop is-half-tablet is-full-mobile"
          >
            <NavigationBox :widget="widget"></NavigationBox>
          </div>
        </div>
        <div class="columns">
          <div class="column-is-full pl-3">
            <div v-if="widget.id == '5'">
              <div
                class="is-size-5 mt-5"
                v-if="$i18n.locale == 'en'"
                v-html="widget.tool_option"
              ></div>
              <div
                class="is-size-5 mt-5"
                v-if="$i18n.locale == 'fr'"
                v-html="widget.tool_optionFr"
              ></div>
            </div>
          </div>
        </div>
      </section>
      <section class="custom-section" ref="browser_support">
        <p class="subtitle is-3">
          {{ $t("browser_support.browser_support_title") }}
        </p>
        <p class="is-size-5 pr-6">
          {{ $t("browser_support.browser_support_text") }}
        </p>
        <br />
        <table>
          <thead>
            <tr>
              <th>IE</th>
              <th>Edge</th>
              <th>Firefox</th>
              <th>Chrome</th>
              <th>Safari</th>
              <th>Opera</th>
              <th>iOS</th>
              <th>Android</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="support-alignment">
                <b-tooltip
                  :label="$t('browser_support.browser_support_no')"
                  type="is-light"
                  position="is-bottom"
                >
                  X
                </b-tooltip>
              </td>
              <td class="support-alignment">
                <b-tooltip
                  :label="$t('browser_support.browser_support_yes')"
                  type="is-light"
                  position="is-bottom"
                >
                  ✓
                </b-tooltip>
              </td>
              <td class="support-alignment">
                <b-tooltip
                  :label="$t('browser_support.browser_support_yes')"
                  type="is-light"
                  position="is-bottom"
                >
                  ✓
                </b-tooltip>
              </td>
              <td class="support-alignment">
                <b-tooltip
                  :label="$t('browser_support.browser_support_yes')"
                  type="is-light"
                  position="is-bottom"
                >
                  ✓
                </b-tooltip>
              </td>
              <td class="support-alignment">
                <b-tooltip
                  :label="$t('browser_support.browser_support_yes')"
                  type="is-light"
                  position="is-bottom"
                >
                  ✓
                </b-tooltip>
              </td>
              <td class="support-alignment">
                <b-tooltip
                  :label="$t('browser_support.browser_support_yes')"
                  type="is-light"
                  position="is-bottom"
                >
                  ✓
                </b-tooltip>
              </td>
              <td class="support-alignment">
                <b-tooltip
                  :label="$t('browser_support.browser_support_yes')"
                  type="is-light"
                  position="is-bottom"
                >
                  ✓
                </b-tooltip>
              </td>
              <td class="support-alignment">
                <b-tooltip
                  :label="$t('browser_support.browser_support_yes')"
                  type="is-light"
                  position="is-bottom"
                >
                  ✓
                </b-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <section
        v-if="widget.id != '5'"
        class="custom-section"
        ref="widget_source"
      >
        <p class="subtitle is-3">
          {{ $t("widget_source.widget_source_title") }}
        </p>
        <p
          class="is-size-5"
          v-if="$i18n.locale == 'fr'"
          v-html="widget.widget_source_fr"
        ></p>
        <p class="is-size-5" v-else v-html="widget.widget_source_en"></p>
        <p class="is-size-5" v-if="widget.id == '3'">
          {{ $t("widget_source.widget_source_faq1") }}
          <a
            @click="scrollMeTo('faq')"
            v-html="$t('widget_source.widget_source_faq2')"
          ></a
          >{{ $t("widget_source.widget_source_faq3")
          }}<!-- need to be with no space after </a> to avoid space between the period -->
        </p>
      </section>
      <!-- widget instructions starts here -->
      <section
        v-if="widget.id != '5'"
        class="custom-section"
        ref="using_the_widget"
      >
        <h2 class="subtitle is-3">{{ $t("widget_details.usage_title") }}</h2>
        <div class="columns">
          <div class="column is-12">
            <p
              class="is-size-5"
              v-html="$t('widget_details.usage_subtitle')"
            ></p>

            <div class="widget-steps" ref="step_one">
              <WidgetInstructionsOne :widget="widget"></WidgetInstructionsOne>
              <ButtonScroll></ButtonScroll>
            </div>
            <div class="widget-steps" ref="step_two">
              <div v-if="!isMobile()">
                <!-- widget builder starts here -->
                <div v-if="widget.id == '3' || widget.id == '4'">
                  <WidgetBuilderLarge :widget="widget"></WidgetBuilderLarge>
                </div>
                <div v-else>
                  <WidgetBuilder :widget="widget"></WidgetBuilder>
                </div>
              </div>
              <div v-else>
                <WidgetInstructionsTwo :widget="widget"></WidgetInstructionsTwo>
              </div>
              <ButtonScroll></ButtonScroll>
            </div>

            <div class="widget-steps" ref="step_three">
              <WidgetInstructionsThree
                :widget="widget"
              ></WidgetInstructionsThree>
              <ButtonScroll></ButtonScroll>
            </div>
            <div
              v-if="widget.id == '1' || widget.id == '2' || widget.id == '4'"
              class="widget-steps"
              ref="step_four"
            >
              <WidgetInstructionsFour :widget="widget"></WidgetInstructionsFour>
              <ButtonScroll></ButtonScroll>
            </div>
            <div
              v-if="widget.id == '1' || widget.id == '2' || widget.id == '4'"
              class="widget-steps"
              ref="step_five"
            >
              <WidgetInstructionsFive :widget="widget"></WidgetInstructionsFive>
              <ButtonScroll></ButtonScroll>
            </div>
          </div>
        </div>
      </section>
      <section
        v-if="widget.id != '5'"
        ref="custom_attributes"
        class="custom-section"
      >
        <!-- custom attributes table starts here -->
        <WidgetAttributesTable :widget="widget"></WidgetAttributesTable>
        <ButtonScroll></ButtonScroll>
      </section>
      <section
        v-if="widget.id != '5'"
        id="faq"
        ref="faq"
        class="custom-section"
      >
        <!-- faq starts here -->
        <WidgetFAQ :widget="widget"></WidgetFAQ>
        <ButtonScroll></ButtonScroll>
      </section>
    </main>
    <BaseFooter></BaseFooter>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import BaseFooter from "@/components/Footer.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import WidgetBuilder from "@/components/WidgetBuilder.vue";
import WidgetBuilderLarge from "@/components/WidgetBuilderLarge.vue";
import WidgetInstructionsOne from "@/components/WidgetInstructionsOne.vue";
import WidgetInstructionsTwo from "@/components/WidgetInstructionsTwo.vue";
import WidgetInstructionsThree from "@/components/WidgetInstructionsThree.vue";
import WidgetInstructionsFour from "@/components/WidgetInstructionsFour.vue";
import WidgetInstructionsFive from "@/components/WidgetInstructionsFive.vue";
import WidgetExample from "@/components/WidgetExample.vue";
import NavigationBox from "@/components/WidgetNavigationBox.vue";
import WidgetAttributesTable from "@/components/WidgetAttributesTable.vue";
import WidgetFAQ from "@/components/WidgetFAQ.vue";
import ButtonScroll from "@/components/ButtonScroll.vue";
import store from "@/store/store.js"; //include vuex store so we can access this from beforeRouteEnter

export default {
  name: "component-details",
  props: {
    lang: {
      type: String,
      default: "en"
    },
    //receives widget as a prop
    widget: {
      type: Object,
      required: true
    }
  },
  components: {
    NavBar,
    BaseFooter,
    Breadcrumb,
    WidgetBuilder,
    WidgetBuilderLarge,
    WidgetInstructionsOne,
    WidgetInstructionsTwo,
    WidgetInstructionsThree,
    WidgetInstructionsFour,
    WidgetInstructionsFive,
    WidgetExample,
    NavigationBox,
    WidgetAttributesTable,
    WidgetFAQ,
    ButtonScroll
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }, // end isMobile
    scrollMeTo: function(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    } // end scrollMeTo
  }, // end methods
  beforeRouteEnter(routeTo, routeFrom, next) {
    //TODO: add progress bar
    store.dispatch("widget/fetchWidget", routeTo.params.id).then(() => {
      //TODO: end progress bar
      next();
    });
  },
  created() {
    if (this.$i18n.locale == "en") {
      document.title =
        this.$t("widget_details.title") + " - " + this.widget.name;
    } else {
      document.title =
        this.$t("widget_details.title") + " - " + this.widget.nameFr;
    }
  },
  updated() {
    if (this.$i18n.locale == "en") {
      document.title =
        this.$t("widget_details.title") + " - " + this.widget.name;
    } else {
      document.title =
        this.$t("widget_details.title") + " - " + this.widget.nameFr;
    }
  }
};
</script>

<style scoped lang="scss">
.example-image {
  margin-top: 2rem;
}
.widget-steps {
  margin-top: 2rem;
}
table,
th,
td {
  border: 1px solid black;
}
th,
td {
  padding: 15px;
  text-align: center;
}
</style>
